/**
 * Assessment scripts
 */

$('#question_help_icon').click(function() {
    $(this).closest('p').next().slideToggle();
});

function pushbtn(event) {

    var keycode = event.keyCode,
        key = String.fromCharCode(keycode),

        // finding the element on which the event
        // was originally fired:
        source = event.target,

        // an Array of element-types upon which
        // the function should not fire (to prevent
        // interfering needlessly with the UI and
        // user-expectations):
        exclude = ['input', 'textarea'];

    if (exclude.indexOf(source.tagName.toLowerCase()) === -1) {
        if(keycode == 39 || keycode == 78){
            $('.next_q').click();
        }
        if(keycode == 37 || keycode == 80){
            $('.prev_q').click();
        }
        console.log('You pressed ' + key + ' (keyCode: ' + keycode + ').');
    }


    //company selector keyboard controls
    if($('.companyListDropdown').hasClass('show')){
        if(keycode === 40){
            //down
            if($("#companyList a").is(":focus")){
                if($(':focus').parent().nextAll(':visible').first().html() != $(':focus').parent().nextAll('li').first().html()){
                    $(':focus').parent().next('li:visible').find('a').focus();
                }
            }else{
                $('#companyList li:visible a').first().focus();
                $('.companyListContainer').animate({ scrollTop: 0 }, "fast");
            }
        }else if(keycode === 38){
            //up
            if($("#companyList a").is(":focus")){
                if($(':focus').parent().prevAll(':visible').first().html() != $(':focus').parent().prevAll('li').first().html()){
                    $(':focus').parent().prev('li:visible').find('a').focus();
                }
            }else{
                console.log('no focus');
                $('#companyList li:visible:last-child a').first().focus();
            }
        }
    }

    return;
}
document.onkeydown = pushbtn;
